import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { AuditViewComponent } from './audit-view.component';

@NgModule({
	declarations: [AuditViewComponent],
	imports: [SharedModule, CommonModule],
	exports: [],
	providers: [],
})
export class AuditViewModule {}
